import { processingGroupIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";
import { ToteNamingConfigSchema } from "./tote-naming-config";

export const updateProcessingGroup = {
  name: "updateProcessingGroup" as const,
  input: z.object({
    id: processingGroupIdFormat.schema,
    name: z.string(),
    toteNamingConfig: ToteNamingConfigSchema.optional(),
  }),
  output: z.null(),
};
